export const state = () => ({
    selectAuthRepresentative: {},
    Result:'',
    editAuthRepresentative:{
        
    },
    birthCountryAuthRepresentative: false

})  